import React from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Email from '@mui/icons-material/Email';
import Lock from '@mui/icons-material/Lock';
import Phone from '@mui/icons-material/Phone';
import LocationCity from '@mui/icons-material/LocationCity';
import Public from '@mui/icons-material/Public';
import './style/CreatingUserFizicheskoyeLitso.css';

function CreatingUserFizicheskoyeLitso() {

return (
    <div className="fiz-litso-create-user-container">
        <div className="fiz-litso-user-section">
            <h2 className="fiz-litso-create-user-title">Регистрация физического лица</h2>
            <form className="fiz-litso-create-user-form">
                <TextField label="Имя" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <AccountCircle className="fiz-litso-input-icon" />, }} />
                <TextField label="Электронная почта" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <Email className="fiz-litso-input-icon" />, }} />
                <TextField label="Телефон" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <Phone className="fiz-litso-input-icon" />, }} />
                <TextField label="Адрес" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <LocationCity className="fiz-litso-input-icon" />, }} />
                <TextField label="Город" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <Public className="fiz-litso-input-icon" />, }} />
                <TextField label="Пароль" type="password" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <Lock className="fiz-litso-input-icon" />, }} />
                    <Button variant="contained" color="primary" type="submit" className="fiz-litso-submit-button">Создать аккаунт</Button>
            </form>
        </div>
    </div>
);
}

export default CreatingUserFizicheskoyeLitso;
